import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Dropdown from '../../atoms/Dropdown'
import { SrOnly, Label } from 'pcln-design-system'

const propTypes = {
  className: PropTypes.string,
  filters: PropTypes.array,
  handleChange: PropTypes.func,
}

const StyledDropdown = styled(Dropdown)`
  margin: 12px 0;
`

const renderDropboxItems = (filters) =>
  filters.map((filter, index) => (
    <Label key={`${filter.name}-dropdown-${index}`}>
      {filter.name && <SrOnly>{filter.name}</SrOnly>}

      <StyledDropdown
        options={filter.options}
        defaultValue={filter.defaultValue}
        data-testid='DROPDOWN_CATEGORY_GROUP'
      />
    </Label>
  ))

const DropdownCategoryGroup = ({ className, filters, handleChange }) => {
  if (!filters) return null
  return (
    <div className={className} onChange={(e) => handleChange(e.target.value, e)}>
      {renderDropboxItems(filters)}
    </div>
  )
}

DropdownCategoryGroup.propTypes = propTypes
export default DropdownCategoryGroup
